import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
  },
  {
    title: "代行者",
    keyword: "agentUserName",
    type: "text",
  },
  {
    title: "代行内容",
    keyword: "agentContent",
    type: "text",
  },
  {
    title: "対象施設",
    keyword: "agentFacilityName",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "staffName",
    type: "text",
    showLine: false,
  },
  {
    title: "タイトル",
    keyword: "requestTitle",
    type: "text",
  },
  {
    title: "対応期日",
    keyword: "dueDate",
    type: "text",
  },
  {
    title: "本文",
    keyword: "requestContent",
    type: "text",
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    showLine: false,
  },
];

export { fakeTableList };
